// extracted by mini-css-extract-plugin
export default {"section":"bzRM6","head":"rkoY1 ZdH1P","headContent":"Yi_0x","description":"uLtuo DS0GQ","title":"vFBoK","priceMin":"Cx30P","arrows":"Axh02","additional":"uUNGV"};